/**
 * Client perks printed on every hotel card of the public page.
 * Resolution order: the trip's own list → the agency template → these
 * defaults. Mirrored in backend/server.py (`DEFAULT_HOTEL_PERKS`).
 * "Complimentary hotel credit per stay" was removed on 2026-06-16 — not
 * every hotel programme includes it.
 */
export const DEFAULT_HOTEL_PERKS = [
  "Upgrade on arrival, subject to availability",
  "Daily breakfast for up to two guests per bedroom",
  "Early check-in / late check-out, subject to availability",
];

export const HOTEL_PERKS_TITLE = "As clients of Espíritu Travel, you enjoy";

/** `own` = the trip's list (an explicit [] hides the section). */
export const resolveHotelPerks = (own, template) => {
  if (Array.isArray(own)) return own.filter(Boolean);
  if (template?.is_set && Array.isArray(template.perks)) return template.perks.filter(Boolean);
  return DEFAULT_HOTEL_PERKS;
};
